import React, { useEffect } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PRIMARY_NAV } from "../resources/menu";
import { PageLoading } from "../components/loading";

/**
 * 登入後的著陸頁：依權限導向第一個可進入的入口。
 * 選單改為 { key, label, path } 結構後導向要用 path——key 現在是設計稿的 route key（如 "today"），
 * 直接拿去 navigate 會被當成相對路徑而導錯。
 *
 * 挑選的來源改成 PRIMARY_NAV 而不是 menus：改版後 menus 幾乎整份都掛了 hidden
 * （它現在的職責是給 routePermissionOf 查權限碼），再從那裡挑「第一個沒 hidden 的」
 * 會一個都挑不到，人人登入都落到退路那頁去。側欄入口本來就是使用者該落地的地方。
 */
function Redirect(props) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!_.isEmpty(props.permissions)) {
      // 權限有兩種形狀：字串陣列，或 /Auth/Function 回來的 [{ module, ... }]。
      // 先攤平成字串再比，否則拿物件去比字串會全部落空，人人都落到退路頁（同 Sider 的處理）。
      const codes = props.permissions.map((p) => (typeof p === "string" ? p : _.get(p, "module", "")));
      const has = (code) => codes.includes(code);
      // permission 為 null 的入口（今天、檢測、設定）登入即可用，也算「可著陸」——
      // 否則權限給得很窄的人會被丟到一頁他打不開的畫面。
      // anyPermission 是「其中之一就算數」（檢測要 codescan 或 vulnscan），
      // 但入口本身 permission 是 null，所以只有 anyPermission 全不中時才排除它。
      const first = PRIMARY_NAV.find((m) => {
        if (m.anyPermission) return _.some(m.anyPermission, has);
        return !m.permission || has(m.permission);
      });
      // 退路是個人工項：合併後的首頁（最上方摘要列＋我的工項清單）
      navigate(first?.path || "/MyTask", { replace: true });
    } else {
      navigate("/Auth/Login", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.permissions]);

  // 轉址前那一下的畫面：跟其他頁的整頁載入同一個樣子（轉圈＋掃光文字）
  return <PageLoading sx={{ minHeight: 400 }} />;
}

const mapStateToProps = (state) => ({
  permissions: _.get(state, "Role.PermissionsUser", []),
});

Redirect.propTypes = { permissions: PropTypes.array };
Redirect.defaultProps = { permissions: [] };

export default connect(mapStateToProps)(Redirect);
